module.exports = __webpack_public_path__ + "static/media/checkerboard.96ac4db2.svg";